module.exports = __webpack_public_path__ + "static/media/enhanced_time.4afe06a2.svg";